import { Box, Grid, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ReactNode } from 'react';
import { ColorShowcase } from 'shared/components/common/color-showcase';

type DetailColumnItem = {
  title: string;
  value?: string | null;
  tooltip?: ReactNode;
  showColorShowcase?: boolean;
};

export type DetailColumn = {
  items: DetailColumnItem[];
};

export const DetailSection = ({ columns }: { columns: DetailColumn[] }) => {
  return (
    <Grid container spacing={4} role="tabpanel">
      {columns.map((column, colIndex) => (
        <FlexGrid key={colIndex} item xs={12} md={4} lg={4}>
          {column.items.map((item, index) => (
            <ItemWrapper key={index}>
              <TitleRow>
                <Typography variant="subtitle2" color="secondary">
                  {item.title}
                </Typography>
                {item.tooltip ?? null}
              </TitleRow>
              {item.showColorShowcase && item.value ? (
                <ColorShowcaseRow>
                  <ColorShowcase hex={item.value} />
                  <Typography variant="body1">{item.value}</Typography>
                </ColorShowcaseRow>
              ) : (
                <Typography variant="body1">{item.value ?? '-'}</Typography>
              )}
            </ItemWrapper>
          ))}
        </FlexGrid>
      ))}
    </Grid>
  );
};

const FlexGrid = styled(Grid)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

const ItemWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),
}));

const TitleRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
  minHeight: 24,
}));

const ColorShowcaseRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
}));
